import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class BreakTypes extends Component {
  render() {
    return (
      <EntityList apiRoute='api/breaktypes' title='Remorque - Types de freins' editTitle='Type de freins' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default BreakTypes;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/breakTypes.js
 **/